export default __webpack_public_path__ + "static/media/sarah.9a976d3e.png";